import { render } from "./PatientCard.vue?vue&type=template&id=0bd6c7ea&scoped=true"
import script from "./PatientCard.vue?vue&type=script&lang=ts"
export * from "./PatientCard.vue?vue&type=script&lang=ts"

import "./PatientCard.vue?vue&type=style&index=0&id=0bd6c7ea&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-0bd6c7ea"

export default script